//////// PARAMETROS
export const APP_OTP_SIZE = 6;

//////// LAYOUT
export const APP_TITLE = '';
export const APP_BG = '/CDN/Get/canjeveranobg';
export const APP_BG_MOBILE = '/CDN/Get/canjeveranobgm';

//////// PAGE HOME
export const HOME_TITLE = 'Festival Cuenta DNI';
export const HOME_ARTIST = 'Babasonicos';
export const HOME_WARMUP = 'Zoe Gotusso';
export const HOME_DATE = '30 de enero - MUTE - Mar del Plata';
export const HOME_SUBTITLE = '¡Te esperamos!';
///HOME_DESCRIPCION sin uso por ahora , se utiliza el mensaje del stage vigente
//export const HOME_DESCRIPCION =
//  'A partir de las 18h podrás disfrutar de la playa, el sol y el show de Babasónicos. <br> <b>Las entradas son gratuitas y exclusivas para la Comunidad Cuenta DNI.</b>';
export const HOME_DESPLEGABLE_TITLE = 'Información importante';
export const HOME_DESPLEGABLE_TEXT =
  'La inscripción es exclusiva para personas usuarias de Cuenta DNI.<br><br>¿Cómo me inscribo?<br><br>- Tocá el botón “Obtené tus entradas”.<br>- Completá tus datos.<br>- Ingresá el código de confirmación que te va a llegar al mail que ingresaste.<br>- Si querés invitar a alguien (sea o no parte de la Comunidad Cuenta DNI), cargá sus datos.<br>- ¡Listo! Ya tenés tus entradas. Vos y tu invitado/a van a recibir la confirmación por mail.<br><br>El día del Festival solo tenés que presentar <b>tu DNI físico</b> para ingresar.<br><br>Las <b>personas menores de edad</b> deberán estar registradas en el formulario e ingresar en compañía de un adulto.<br><br>Apertura de puertas: 18:00<br><br>Finalización del show: 23:30<br><br><b>En caso de lluvia, el Festival será reprogramado para el sábado 31.</b><br><br>No podrás ingresar con:<br><br>- Armas de fuego o pirotecnia.<br>- Elementos punzantes.<br>- Paraguas.<br>- Líquidos o gases inflamables.<br>- Heladeras.<br>- Aerosoles.<br>- Selfie stick.<br>- Drones.<br><br><a target="_blank" href="/CDN/Get/canje_babasonicos_25"> Hacé clic acá y conocé los Términos y Condiciones.</a></div>';
export const HOME_EVENTOS = [
  {
    imagen: '/CDN/Get/canje_item_1',
    titulo: 'Babasonicos',
    subtitulo: '',
    id: 1,
  },
  {
    imagen: '/CDN/Get/canje_item_2',
    titulo: 'Zoe Gotusso',
    subtitulo: '',
    id: 1,
  },
  {
    imagen: '/CDN/Get/canje_item_3',
    titulo: 'Festival Cuenta DNI',
    subtitulo: '',
    id: 1,
  },
];

//////// PAGE CANJE
export const CANJE_LOGIN_TITLE = '¡Completá el formulario para adquirir tus entradas!';
export const CANJE_OTP_TITLE = 'Te enviamos un código a tu mail</br> Revisá tu correo e ingresá el número';
export const CANJE_INVITADOS_TITLE = (cantMaxima: number) => {
  return cantMaxima > 0
    ? `¡Genial! Ahora podés invitar a ${GET_CANT_STRING(cantMaxima)} ${
        cantMaxima > 1 ? 'personas' : 'persona'
      }  al Festival Cuenta DNI. Ingresá sus datos.`
    : '¡Genial! Sos Cuenta DNI. Podes obtener tu entrada.';
};
export const CANJE_BUTTON_TEXT = (invitados: number, cantMaxima: number) => {
  if (cantMaxima > 0) {
    return invitados > 0 ? 'Confirmar' : 'Obtener entrada sin invitada/o';
  } else {
    return 'Confirmar';
  }
};

export const GET_CANT_STRING = (cant: number): string => {
  switch (cant) {
    case 1:
      return 'una';
    case 2:
      return 'dos';
    case 3:
      return 'tres';
    case 4:
      return 'cuatro';
    default:
      return '';
  }
};

export const CANJE_CONFIRMATION =
  'Para revisar los datos ingresados, cerrá este aviso (X). Una vez enviados, no podrán modificarse.<br><br>¿Querés enviar el formulario?';
export const CANJE_SUCCESS_MSG = `<b style="font-size: 22px; color: white;">¡Formulario recibido con éxito!</b><br>Te enviaremos un correo con toda la información.<br><br>¡Te esperamos el 30 de enero!<br><br><b>Recordá que la entrada al Festival es tu DNI físico. ¡No te lo olvides!</b>`;
export const CANJE_TOO_MANY_REQUESTS = 'Hay muchas personas queriendo ingresar, por favor volvé a intentarlo.';
export const CANJE_INVALID_TOKEN = 'El token ingresado es incorrecto, por favor volvé a intentarlo.';

//////// PAGE VALIDATE
export const VALIDATE_TITLE = 'Festival Cuenta DNI';
export const VALIDATE_SUBTITLE = 'Ingresá tu DNI y verificá si tenés tu ingreso';
export const VALIDATE_SUCCESS_MSG =
  '<span style="font-size:23px">¡El DNI ingresado tiene una entrada válida!</span><br>Te enviamos un correo de confirmación, pero no te preocupes porque el ingreso al Festival es tu DNI físico.<br><b>¡No te lo olvides!</b><br>Te esperamos el 30/01 en MUTE Mar del Plata.';
export const VALIDATE_ERROR_MSG = '<b>El DNI ingresado no tiene una entrada válida.</b>';
export const VALIDATE_ERROR_FORMAT_MSG = 'Hubo un error al validar el DNI, intentá nuevamente más tarde.';
